module.exports = __webpack_public_path__ + "img/lixiuhua.9b313650.jpg";